window.loadIMG = {
  configNum:1,
  institution: "小芒果",
  systemName: "小芒果教务机构管理系统",
  bgTitle: "带您开启教学数字化之旅",
  link: "www.xiaohebang.cn",
  corporateName: "湖北云铺网络科技有限公司",
  corporateUser: "张龙",
  corporatePhone: "4008959724",
  corporateAddress: "湖北省宜昌市西陵区发展大道55号创业中心506",
  salesPhone: "4008806820", //售后电话
  emptyImage: "https://pxboss.xiaohebang.cn/system/material/com/empty.png", //无数据 提示图 不写就不显示
  homePagebg:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/homePageBg.png", //homepage页背景
  myPagebg:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/homePageBg.png", //selfpage页背景
  noticIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/notic.png", //homepage 滚动通知栏的小喇叭
  indexIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/tabbar/indexIcon.png", //首页 没选中
  indexIconA:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/tabbar/indexIconA.png", //首页选中
  myIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/tabbar/myIcon.png", // 我的 没选中
  myIconA:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/tabbar/myIconA.png", //我的 选中

  bgimg:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/mybg.png", //我的页面  学员详情 的背景
  bgimg1:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/mybg.png", //充值页面  的背景

  backgroundImage:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/newLoginbg.png", //登录页背景

  aboutmeImg: "https://pxboss.xiaohebang.cn/system/default/logo3.png", //关于我们

  qrCode:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/qrCode.png", //我的页面 二维码
  bluePen:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/bluePen.png", //我的页面编辑按钮
  tjyj:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/tjyj.png", //我的 推荐有奖
  yjfk:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/yjfk.png", // 我的 意见反馈
  gywm:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/gywm.png", // 我的 关于我们
  zxzh:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/zxzh.png", // 我的 注销账号
  moreIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/more.png", //首页 更多
  boy: "https://pxboss.xiaohebang.cn/system/material/com/boy.png", //男生
  girl: "https://pxboss.xiaohebang.cn/system/material/com/girl.png", //女生
  youArrow: "https://pxboss.xiaohebang.cn/system/default/om/right.png", //右箭
  registerbg:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/registerbg.png", //注册页
  refreshBtn:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/refreshBtn.png",
  arrowDm:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/arrowDm.png",

  jwsj: [
    { name: "0", label: "数据概况" },
    { name: "1", label: "授课统计" }
    // { name: "dayData2", label: "课消统计" },
  ],
  zssj: [
    { name: "0", label: "数据概况" },
    { name: "2", label: "招生排名" },
    { name: "1", label: "招生趋势" }
  ],
  xssj: [
    { name: "0", label: "数据概况" },
    { name: "1", label: "销售额分析" },
    { name: "2", label: "销售额月统计" }
  ],
  status1: "https://pxboss.xiaohebang.cn/system/default/om/xhb/status1.jpg",
  status2: "https://pxboss.xiaohebang.cn/system/default/om/xhb/status2.jpg",
  status3: "https://pxboss.xiaohebang.cn/system/default/om/xhb/status3.jpg",
  blackPanel:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/blackPanel.png"
};



// WEBPACK FOOTER //
// ./src/style_omg/loadimage.js